import { mapDictionaryKey } from "components/Filters/helpers";
import { SEARCH_STACK_SUGGESTIONS_DICTIONARY, StackSuggestions } from "constants/stack";

export const getFilterKey = (key: StackSuggestions | string) => {
  return mapDictionaryKey(key, SEARCH_STACK_SUGGESTIONS_DICTIONARY);
};
